import React from 'react'

function ContactUs() {

    return (
        <>
            <div className='mt-[80px]'>
                <div className='relative'>
                    <img src="/assets/impact/bg3.png" className='w-full' alt="" />
                    <div className='absolute md:bottom-[60px] bottom-[10px] left-[50%] translate-x-[-50%]'>
                        <h2 className="font-[700] font-manrope md:text-[50px] text-[30px] text-[#FFFFFF] tracking-[3px] text-center">Contact Us</h2>
                        <p className="font-[500] font-manrope text-[16px] text-[#FFFFFF] tracking-[3px] text-center">HOME-Contact</p>
                    </div>
                </div>
            </div>
            <section className="md:pt-[90px] pt-[50px] md:px-[178px] px-[20px]">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[40px]">
                    <div
                        className="flex flex-col items-center gap-[8px] bg-[#FFFFFF] rounded-[16px] relative w-full"
                        style={{ boxShadow: "0px 0px 4px 0px #00000014" }}
                    >
                        <img src="/assets/impact/item1.svg" className='w-full absolute top-0' alt="" />
                        <img src="/assets/impact/img2.png" className='relative z-10 pt-[23px]' alt="" />
                        <h6 className="text-center font-[700] font-manrope text-[20px] text-[#333333]">Address</h6>
                        <p className="font-[400] max-w-[155px] w-full mx-auto font-manrope text-[16px] leading-[20px] text-center pb-[39px] text-[#4D4D4D]">100 Warren St
                            Jersey City, NJ 07302</p>
                    </div>
                    <div
                        className="flex flex-col items-center gap-[8px] bg-[#FFFFFF] rounded-[16px] relative w-full"
                        style={{ boxShadow: "0px 0px 4px 0px #00000014" }}
                    >
                        <img src="/assets/impact/item1.svg" className='w-full absolute top-0' alt="" />
                        <img src="/assets/impact/img3.png" className='relative z-10 pt-[23px]' alt="" />
                        <h6 className="text-center font-[700] font-manrope text-[20px] text-[#333333]">Mail</h6>
                        <p className="font-[400] max-w-[155px] w-full mx-auto font-manrope text-[16px] leading-[20px] text-center pb-[39px] text-[#4D4D4D]">info@example.com <br /> volunteer@example.com</p>
                    </div>
                    <div
                        className="flex flex-col items-center gap-[8px] bg-[#FFFFFF] rounded-[16px] relative w-full"
                        style={{ boxShadow: "0px 0px 4px 0px #00000014" }}
                    >
                        <img src="/assets/impact/item1.svg" className='w-full absolute top-0' alt="" />
                        <img src="/assets/impact/img3.png" className='relative z-10 pt-[23px]' alt="" />
                        <h6 className="text-center font-[700] font-manrope text-[20px] text-[#333333]">Call</h6>
                        <p className="font-[400] max-w-[155px] w-full mx-auto font-manrope text-[16px] leading-[20px] text-center pb-[39px] text-[#4D4D4D]">+91 7896963698 <br />
                            +91 7896963698</p>
                    </div>
                </div>
            </section>
            <section className='pt-[90px] md:px-[177px] px-[20px]'>
                <p className="text-primary-orange text-center">CONTACT</p>
                <h6 className="text-center max-w-[572px] w-full mx-auto text-heading-primary text-[#2D190D] lg:pb-[80px] pb-[40px]">Join with us to As <span className='text-[#FF6000]'>Contact Now!</span></h6>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-[30px] items-start md:pb-[160px] pb-[60px]">
                    <div className='bg-[#FFFFFF] rounded-[16px] px-[30px] py-[36px]' style={{ boxShadow: "0px 0px 4px 0px #00000014" }}>
                        <h6 className="font-[700] text-[24px] font-manrope text-[#333333] pb-[22px]">Have a Question? Drop Us a Line!</h6>
                        <div className="flex flex-col gap-[16px]">
                            <input type="text" className='input-box' placeholder='Name' />
                            <input type="email" className='input-box' placeholder='Email' />
                            <textarea name="" id="" rows="4" className='input-box mb-[56px]' placeholder='Message'></textarea>
                              <button className='d-btn'>SEND MESSAGE</button>
                        </div>
                    </div>
                    <div>
                        <img src="/assets/impact/map.png" className='w-full' alt="" />
                    </div>
                </div>
            </section>
        </>
    )
}

export default ContactUs